import {
  Breadcrumb,
  Calendar,
  Callout,
  DayOfWeek,
  DefaultButton,
  DetailsHeader,
  DetailsListLayoutMode,
  DirectionalHint,
  Dropdown,
  Fabric,
  FocusTrapZone,
  IColumn,
  IDetailsGroupDividerProps,
  IDetailsGroupRenderProps,
  IDetailsHeaderProps,
  IDropdownOption,
  IGroup,
  IGroupDividerProps,
  IListProps,
  IRenderFunction,
  PrimaryButton,
  SelectionMode,
  ShimmeredDetailsList,
  Stack,
  Text,
  TextField,
  TooltipHost,
} from "office-ui-fabric-react";
import React from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  IDataCenter,
  IPowerReportConfigurations,
  ISearchTransactions,
  ITempRhReadings,
} from "../../../vm";
import moment from "moment";
import {
  deleteTempAndRhPage,
  getAllCustomers,
  getCustomerTempHumidity,
  getDatacentersForACustomer,
  getPowerReportConfigurations,
  updateTempAndHumidity,
} from "../../../services/customers/CustomerService";
import {
  API_URL,
  childrenGap,
  childrenGap8,
  DayPickerStrings,
} from "../../common/Constants";
import { ToastContext } from "../../common/ToastProvider";
import Icon from "@mdi/react";
import {
  mdiArrowDown,
  mdiArrowUp,
  mdiCheckCircleOutline,
  mdiChevronDown,
  mdiChevronRight,
  mdiCloseCircleOutline,
  mdiDotsVertical,
  // mdiEyeOutline,
  // mdiLeadPencil,
  // mdiPencilOutline,
} from "@mdi/js";
import { THEME } from "../../../utils/Styles";
import {
  getToken,
  parseJwt,
  toFixedValue,
} from "../../../services/UtilService";
import ManageTemperatureHumidityDetails from "./ManageTemperatureHumidityDetails";
import { getSLAMatrixConfig } from "../../../services/sla-matrix/SlaMatrixService";
import { Loading } from "../../../services/Loading";
import ManageTempRhPageDialog from "./ManageTempRhPageDialog";
import TempRhRemarks from "./TempRhRemarks";
import CustomDrawer from "../../common/CustomDrawer";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";

export interface TemperatureHumidityMainProps {
  customerName: string;
}

let calendarButtonElement: HTMLElement;

const TemperatureHumidityMain: React.FC<TemperatureHumidityMainProps> = ({
  customerName,
}) => {
  //hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const tokenData = parseJwt();

  const queryParams = new URLSearchParams(window.location.search);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isTempFound: false,
    date: queryParams.get("date")
      ? new Date(queryParams.get("date") as string)
      : new Date(),
    showCallender: false,
    searchObj: {
      customerId: params.customerId,
      startDate: queryParams.get("date")
        ? new Date(queryParams.get("date") as string)
        : new Date(),
      endDate: queryParams.get("date")
        ? new Date(queryParams.get("date") as string)
        : new Date(),
      datacenterId: "",
    },
    tempHumidity: [],
    group: [],
    // customer: {
    //   name: "",
    // },
    manageTempRhDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    slaMatrix: {},
    tempRhObj: {
      date: new Date(),
      temp: 0,
      rh: 0,
      // sensorId: "",
      // quadrantId: "",
      // floorId: "",
      // datacenterId: "",
      // customerId: params.customerId,
      tempRhPageId: "",
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
    isOnEdit: false,
    datacenters: [],
    datacenterDropdown: [],
    powerReportConfig: [],
    managePageDialog: {
      isOpen: false,
      tempRhPageId: "",
    },
    manageRemarksDialog: {
      isOpen: false,
      tempRhPageId: "",
      pageName: "",
    },
    manageHeaderActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    isTempFound: boolean;
    date: Date;
    showCallender: boolean;
    searchObj: ISearchTransactions;
    tempHumidity: any[];
    group: IGroup[];
    // customer: any;
    manageTempRhDialog: {
      isOpen: boolean;
      index?: number;
      data?: any;
    };
    slaMatrix: any;
    tempRhObj: ITempRhReadings;
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: any;
    };
    isOnEdit: boolean;
    datacenters: IDataCenter[];
    datacenterDropdown: IDropdownOption[];
    powerReportConfig: IPowerReportConfigurations[];
    managePageDialog: {
      isOpen: boolean;
      tempRhPageId: string;
    };
    manageRemarksDialog: {
      isOpen: boolean;
      tempRhPageId: string;
      pageName: string;
    };
    manageHeaderActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IDetailsGroupDividerProps;
    };
  });

  React.useEffect(() => {
    const asyncFunc = () => {
      getAllDatacenter();
    };
    asyncFunc();
  }, []);

  const getAllDatacenter = async () => {
    setState({ ...state, isLoading: true });
    let result = await getDatacentersForACustomer({
      customerId: params.customerId,
    });
    if (result?.success) {
      let datacenterDropdown: IDropdownOption[] = [];

      result.data?.forEach((item) => {
        datacenterDropdown.push({
          key: item._id as string,
          text: item.name,
        });
      });

      let obj = {
        ...state,
        datacenters: result.data,
        datacenterDropdown,
        searchObj: {
          ...state.searchObj,
          datacenterId: result.data[0]?._id,
        },
      };
      setState(obj);
      getPowerReportConfig(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting datacenters", "error");
    }
  };

  const getPowerReportConfig = async (paramState?: any) => {
    let localState = { ...state };

    if (paramState != null) {
      localState = { ...localState, ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let result = await getPowerReportConfigurations({
      customerId: params.customerId,
    });
    if (result?.success) {
      let powerReportConfig: IPowerReportConfigurations[] = [];

      localState.datacenters.forEach((datacenter: IDataCenter) => {
        let item = result.data.find((i) => i.datacenterId === datacenter._id);
        if (item) {
          // item["datacenterName"] = datacenter.name;
          powerReportConfig.push(item);
        } else {
          powerReportConfig.push({
            datacenterId: datacenter._id as string,
            // datacenterName: datacenter.name,
            customerId: params.customerId,
            dedicated: [],
            rackwise: [],
            groupByPdu: "floor-wise",
            groupByTempRh: "quadrant-wise",
          });
        }
      });
      let obj = {
        ...localState,
        powerReportConfig,
        isLoading: false,
      };
      setState(obj);
      // getTempHumidity(obj);
      getSlaMatrix(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting minimum committed power",
        "error"
      );
    }
  };

  const getSlaMatrix = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let result = await getSLAMatrixConfig(params.customerId);
    if (result?.success) {
      let obj = {
        ...localState,
        slaMatrix: result.data || { humidity: {}, temperature: {} },
        isLoading: false,
      };
      setState(obj);
      getTempHumidity(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Error while getting sla matrixes", "error");
    }
  };

  const getTempHumidity = async (paramState?: any) => {
    let localState = { ...state };

    if (paramState != null) {
      localState = { ...localState, ...paramState };
    }
    setState({ ...localState, isLoading: true });

    let tempSearch = { ...localState.searchObj };

    tempSearch.startDate = moment(tempSearch.startDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    // .toDate();
    tempSearch.endDate = moment(tempSearch.endDate)
      .endOf("month")
      .format("YYYY-MM-DD");
    // .toDate();

    let result = await getCustomerTempHumidity(tempSearch);
    if (result?.success) {
      let group: IGroup[] = [];
      let tempHumidity: any[] = [];
      let startIndex = 0;

      result.data.forEach((item: any) => {
        group.push({
          key: item.pageId,
          // key: item.id,
          name: item.pageName + " ",
          // name: "Temperature & Humidity in " + item.pageName + " ",
          // +data.floorDict[item.quadrantId].datacenter
          startIndex: startIndex,
          count: item.data.length,
        });
        startIndex += item.data.length;

        item.data.forEach((ele: any) => {
          tempHumidity.push({
            date: ele.date,
            actualDate: ele.actualDate,
            temp: ele.temp,
            rh: ele.rh,
            tempRhPageId: item.pageId,
            // floorId: item.groupBy === "floor-wise" ? item.id : undefined,
            // quadrantId: item.groupBy === "quadrant-wise" ? item.id : undefined,
            // datacenterId: item.groupBy === "dc-wise" ? item.id : undefined,
          });
        });
      });
      // data.readings.map((item: any) => {
      //   group.push({
      //     key: item.quadrantId,
      //     name:
      //       'Temperature & Humidity in ' +
      //       data.floorDict[item.quadrantId].datacenter +
      //       '-' +
      //       data.floorDict[item.quadrantId].buildingName +
      //       '-' +
      //       data.floorDict[item.quadrantId].floorName +
      //       '-' +
      //       data.floorDict[item.quadrantId].quadrantName +
      //       ' ',
      //     // +data.floorDict[item.quadrantId].datacenter
      //     startIndex: startIndex,
      //     count: item.data.length,
      //   });
      //   startIndex += item.data.length;

      //   item.data.map((ele: any) => {
      //     tempHumidity.push({
      //       date: ele.date,
      //       temp: ele.temp,
      //       rh: ele.rh,
      //       floorId: item.floorId,
      //       quadrantId: item.quadrantId,
      //     });
      //   });
      // });

      let obj = {
        ...localState,
        tempHumidity,
        group,
        isTempFound: true,
        isLoading: false,
        // customer: result.data[0],
      };
      setState(obj);
      // getSlaMatrix(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting Temperature & Humidity",
        "error"
      );
    }
  };

  // const getACustomer = async (data: any) => {
  //   setState({ ...state, isLoading: true });
  //   let result = await getAllCustomers({ customerId: params.customerId });
  //   if (result && result.success && result.data.length > 0) {
  //     let group: IGroup[] = [];
  //     let tempHumidity: any[] = [];
  //     let startIndex = 0;

  //     data.readings.map((item: any) => {
  //       group.push({
  //         key: item.quadrantId,
  //         name:
  //           "Temperature & Humidity in " +
  //           data.floorDict[item.quadrantId].datacenter +
  //           "-" +
  //           data.floorDict[item.quadrantId].buildingName +
  //           "-" +
  //           data.floorDict[item.quadrantId].floorName +
  //           "-" +
  //           data.floorDict[item.quadrantId].quadrantName +
  //           " ",
  //         // +data.floorDict[item.quadrantId].datacenter
  //         startIndex: startIndex,
  //         count: item.data.length,
  //       });
  //       startIndex += item.data.length;

  //       item.data.map((ele: any) => {
  //         tempHumidity.push({
  //           date: ele.date,
  //           temp: ele.temp,
  //           rh: ele.rh,
  //           floorId: item.floorId,
  //           quadrantId: item.quadrantId,
  //         });
  //       });
  //     });
  //     // data.readings.map((item: any) => {
  //     //   group.push({
  //     //     key: item.floorId,
  //     //     name:
  //     //       "Temperature & Humidity in Tower " +
  //     //       data.floorDict[item.floorId].buildingName +
  //     //       " " +
  //     //       data.floorDict[item.floorId].floorName +
  //     //       " Floor " +
  //     //       data.floorDict[item.floorId].datacenter,
  //     //     startIndex: startIndex,
  //     //     count: item.data.length,
  //     //   });
  //     //   startIndex += item.data.length;

  //     //   item.data.map((ele: any) => {
  //     //     tempHumidity.push({
  //     //       date: ele.date,
  //     //       temp: ele.temp,
  //     //       rh: ele.rh,
  //     //       floorId: item.floorId,
  //     //     });
  //     //   });
  //     // });
  //     let obj = {
  //       ...state,
  //       tempHumidity,
  //       group,
  //       isTempFound: true,
  //       isLoading: false,
  //       customer: result.data[0],
  //     };
  //     setState(obj);
  //     getSlaMatrix(obj);
  //   } else {
  //     setState({ ...state, isLoading: false });
  //     showToast(
  //       result.message || "Error while getting customer details",
  //       "error"
  //     );
  //   }
  // };

  const _onRenderDetailsHeader = (
    props: IDetailsHeaderProps,
    _defaultRender?: IRenderFunction<IDetailsHeaderProps>
  ) => {
    return (
      <DetailsHeader
        {...props}
        ariaLabelForToggleAllGroupsButton={"Expand collapse groups"}
      />
    );
  };

  const _onRenderGroupHeader: IDetailsGroupRenderProps["onRenderHeader"] = (
    props
  ) => {
    if (props) {
      return (
        <Stack
          horizontal
          wrap
          tokens={childrenGap}
          horizontalAlign="space-between"
          style={{
            paddingLeft: props.cellStyleProps?.cellLeftPadding,
            paddingRight: props.cellStyleProps?.cellRightPadding,
            paddingTop: 8,
            paddingBottom: 8,
          }}
        >
          <Stack.Item>
            <Stack
              horizontal
              tokens={childrenGap}
              onClick={() =>
                props.onToggleCollapse &&
                props.onToggleCollapse(props.group as IGroup)
              }
            >
              <Stack.Item>
                <Icon
                  path={
                    props.group?.isCollapsed ? mdiChevronRight : mdiChevronDown
                  }
                  size={0.7}
                  className="pointer"
                  color="#383737"
                />
              </Stack.Item>
              <Stack.Item>
                <Text
                  className={
                    !props.group?.isCollapsed ? "text-bold pointer" : "pointer"
                  }
                >{`${props.group?.name} ${
                  props.group?.count ? `(${props.group.count})` : ""
                }`}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
          <Stack.Item>
            <span
              onClick={(ele) =>
                handleHeaderCallOutOpenClose(true, ele, props.groupIndex, props)
              }
            >
              <Icon
                path={mdiDotsVertical}
                size={0.9}
                className="pointer"
                color="#383737"
              />
            </span>
            {/* <Stack horizontal tokens={childrenGap}>
          <Stack.Item>
          <TooltipHost
                    content={`Edit Page`}
                    id={`editTempRh`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span onClick={() => handlePageDialogOpenClose(true, props.groupIndex)}>
                      <Icon
                        path={mdiPencilOutline}
                        size={0.8}
                        className="pointer"
                        color="#383737"
                      />
                    </span>
                  </TooltipHost>
          </Stack.Item>
          <Stack.Item>
          <TooltipHost
                    content={`View Remarks`}
                    id={`viewremarks`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span onClick={() => handleRemarksDialogOpenClose(true, props.groupIndex)}>
                      <Icon
                        path={mdiEyeOutline}
                        size={0.8}
                        className="pointer"
                        color="#383737"
                      />
                    </span>
                  </TooltipHost>
          </Stack.Item>
          <Stack.Item>
          <TooltipHost
                    content={`Download Report`}
                    id={`downloadReport`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span onClick={() => !state.isLoading ? downloadTempRhReportPdf(props.group?.key as string, props.group?.name as string) : undefined}>
                      <Icon
                        path={mdiArrowDown}
                        size={0.8}
                        className="pointer"
                        color="#383737"
                      />
                    </span>
                  </TooltipHost>
          </Stack.Item>
          </Stack> */}
          </Stack.Item>
        </Stack>
      );
    }
    return null;
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: any
  ) => {
    setState({
      ...state,
      isOnEdit: false,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  const handleHeaderCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IDetailsGroupDividerProps
  ) => {
    setState({
      ...state,
      manageHeaderActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  const handlePageDialogOpenClose = (
    isOpen: boolean,
    index?: number,
    shouldReload?: boolean
  ) => {
    let tempRhPageId = "";
    if (index !== undefined) {
      tempRhPageId = state.group[index].key;
    }
    const obj = {
      ...state,
      managePageDialog: { ...state.managePageDialog, isOpen, tempRhPageId },
    };
    setState(obj);
    if (shouldReload) {
      getTempHumidity(obj);
    }
  };

  const handleRemarksDialogOpenClose = (isOpen: boolean, index?: number) => {
    let tempRhPageId = "";
    let pageName = "";
    if (index !== undefined) {
      tempRhPageId = state.group[index].key;
      pageName = String(state.group[index].name).replace(
        "Temperature & Humidity in ",
        ""
      );
    }
    const obj = {
      ...state,
      manageRemarksDialog: {
        ...state.manageRemarksDialog,
        isOpen,
        tempRhPageId,
        pageName,
      },
    };
    setState(obj);
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <>
            {state.isOnEdit && state.manageActionsCallout.index === index ? (
              <Stack horizontal tokens={childrenGap}>
                <React.Fragment>
                  <TooltipHost
                    content={`Save`}
                    id={`saveTempRh`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span onClick={onUpdateTempRh}>
                      <Icon
                        path={mdiCheckCircleOutline}
                        size={0.8}
                        className="pointer"
                        color="green"
                      />
                    </span>
                  </TooltipHost>
                  <TooltipHost
                    content={`Cancel`}
                    id={`cancelTempRh`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span
                      onClick={() =>
                        setState({
                          ...state,
                          isOnEdit: false,
                          tempRhObj: {
                            date: new Date(),
                            temp: 0,
                            rh: 0,
                            // sensorId: "",
                            // quadrantId: "",
                            // floorId: "",
                            // datacenterId: "",
                            tempRhPageId: "",
                          },
                          manageActionsCallout: {
                            isOpen: false,
                            index: undefined,
                            element: undefined,
                            data: undefined,
                          },
                        })
                      }
                    >
                      <Icon
                        path={mdiCloseCircleOutline}
                        size={0.8}
                        className="pointer"
                        color="red"
                      />
                    </span>
                  </TooltipHost>
                </React.Fragment>
              </Stack>
            ) : (
              <span
                onClick={(ele) =>
                  handleCallOutOpenClose(true, ele, index, item)
                }
              >
                <Icon
                  path={mdiDotsVertical}
                  size={0.9}
                  className="pointer"
                  color="#135c8a"
                />
              </span>
            )}
          </>
        );
      case "temp":
        return (
          <React.Fragment>
            {state.isOnEdit && state.manageActionsCallout.index === index ? (
              <TextField
                value={String(state.tempRhObj.temp)}
                type="number"
                name="temp"
                onChange={handleChange}
                // className="width-80"
              />
            ) : (
              <React.Fragment>
                <span
                  className={
                    isTempNotInThreshold(item.temp) ? "text-danger" : ""
                  }
                >
                  {/* {item.temp.toFixed(2)} */}
                  {toFixedValue(item.temp)}
                </span>
                {isTempNotInThreshold(item.temp) && (
                  <Icon
                    path={
                      item.temp < state.slaMatrix.temperature.min
                        ? mdiArrowDown
                        : mdiArrowUp
                    }
                    size={0.5}
                    color="#D62828"
                    style={{ marginBottom: -2 }}
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        );
      case "rh":
        return (
          <React.Fragment>
            {state.isOnEdit && state.manageActionsCallout.index === index ? (
              <TextField
                value={String(state.tempRhObj.rh)}
                type="number"
                name="rh"
                onChange={handleChange}
                // className="width-80"
              />
            ) : (
              <React.Fragment>
                <span
                  className={
                    item.rh !== "NA" && isRhNotInThreshold(item.rh)
                      ? "text-danger"
                      : ""
                  }
                >
                  {/* {item.rh.toFixed(2)} */}
                  {toFixedValue(item.rh)}
                </span>
                {item.rh !== "NA" && isRhNotInThreshold(item.rh) && (
                  <Icon
                    path={
                      item.rh < state.slaMatrix.humidity.min
                        ? mdiArrowDown
                        : mdiArrowUp
                    }
                    size={0.5}
                    color="#D62828"
                    style={{ marginBottom: -2 }}
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        );
      case "date":
        return (
          <Text style={{ fontWeight: 600 }}>
            {item.date}
            {/* {moment(item.date).format("DD-MMM")} */}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const handleChange = (e: any) => {
    setState({
      ...state,
      tempRhObj: {
        ...state.tempRhObj,
        [e.target.name]: e.target.value,
      },
    });
  };

  const onUpdateTempRh = async () => {
    let tempRhObj = { ...state.tempRhObj };
    tempRhObj.temp = Number(tempRhObj.temp);
    tempRhObj.rh = Number(tempRhObj.rh);
    tempRhObj.date = moment(tempRhObj.date).format("YYYY-MM-DD");

    if (!state.tempRhObj.temp) {
      tempRhObj.temp = 0;
    }
    if (!state.tempRhObj.rh) {
      tempRhObj.rh = 0;
    }
    setState({ ...state, isLoading: true });
    let result = await updateTempAndHumidity(tempRhObj);
    if (result?.success) {
      let tempAndHumidity = [...state.tempHumidity];
      if (state.manageActionsCallout.index !== undefined) {
        tempAndHumidity[state.manageActionsCallout.index].temp =
          state.tempRhObj.temp || 0;
        tempAndHumidity[state.manageActionsCallout.index].rh =
          state.tempRhObj.rh || 0;
      }
      setState({
        ...state,
        tempRhObj: {
          date: new Date(),
          temp: 0,
          rh: 0,
          // sensorId: "",
          // quadrantId: "",
          // floorId: "",
          // datacenterId: "",
          tempRhPageId: "",
        },
        isOnEdit: false,
        manageActionsCallout: {
          isOpen: false,
          index: undefined,
          element: undefined,
          data: undefined,
        },
        isLoading: false,
      });
      showToast("Temp & Rh value updated successfully", "success");
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Error while updating temp & rh", "error");
    }
  };

  const isTempNotInThreshold = (tempValue: number) => {
    if (!state.slaMatrix.temperature) return false;
    if (
      tempValue < state.slaMatrix.temperature.min ||
      tempValue > state.slaMatrix.temperature.max
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isRhNotInThreshold = (rhValue: number) => {
    if (!state.slaMatrix.humidity) return false;
    if (
      rhValue < state.slaMatrix.humidity.min ||
      rhValue > state.slaMatrix.humidity.max
    ) {
      return true;
    } else {
      return false;
    }
  };

  const shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
  };

  const onSearch = async () => {
    if (!state.date) {
      showToast("Please select a date before searching", "error");
    }

    getTempHumidity();
  };

  const deletePage = async (tempRhPageId: string, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete this Page",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageHeaderActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteTempAndRhPage(tempRhPageId);
        if (result?.success) {
          showToast("Temp/Rh Page deleted successfully", "success");
          let group = [...state.group];
          group.splice(index, 1);
          setState({
            ...state,
            group,
            isLoading: false,
            manageHeaderActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageHeaderActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting temp/rh page",
            "error"
          );
        }
      }
    );
  };

  // const downloadTempRhReportPdf = async () => {
  //   let result = await fetch(
  //     `${API_URL}temp-rh/report?customerId=${
  //       state.searchObj.customerId
  //     }&startDate=${moment(state.searchObj.startDate)
  //       .startOf("month")
  //       .format("YYYY-MM-DD")}&endDate=${moment(state.searchObj.endDate)
  //       .endOf("month")
  //       .format("YYYY-MM-DD")}&datacenterId=${state.searchObj.datacenterId}`,
  //     {
  //       method: "GET",
  //       headers: {
  //         at: getToken(),
  //       },
  //     }
  //   );
  //   let pdf = await result.blob();
  //   const pdfFile = await new Blob([pdf], { type: "application/pdf" });
  //   const pdfFileURL = await URL.createObjectURL(pdfFile);
  //   var a: any = document.createElement("a");
  //   document.body.appendChild(a);
  //   a.style = "display:none";
  //   a.href = pdfFileURL;
  //   // a.download = `${state.customer.name} Monthly Temp & Humidity Report.pdf`;
  //   a.download = `${customerName} Monthly Temp & Humidity Report.pdf`;
  //   a.click();
  // };

  const downloadTempRhReportPdf = async (
    tempRhpageId: string,
    pageName: string
  ) => {
    setState({
      ...state,
      manageHeaderActionsCallout: {
        isOpen: false,
        element: undefined,
        index: undefined,
        data: undefined,
      },
    });
    let result = await fetch(
      `${API_URL}temp-rh/report?tempRhPageId=${tempRhpageId}&startDate=${moment(
        state.searchObj.startDate
      )
        .startOf("month")
        .format("YYYY-MM-DD")}&endDate=${moment(state.searchObj.endDate)
        .endOf("month")
        .format("YYYY-MM-DD")}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
        },
      }
    );
    let pdf = await result.blob();
    const pdfFile = await new Blob([pdf], { type: "application/pdf" });
    const pdfFileURL = await URL.createObjectURL(pdfFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = pdfFileURL;
    // a.download = `${state.customer.name} Monthly Temp & Humidity Report.pdf`;
    a.download = `${customerName} ${pageName} Monthly Temp & Humidity Report.pdf`;
    a.click();
  };

  const downloadTempRhReportExcel = async (
    tempRhPageId: string,
    pageName: string
  ) => {
    setState({
      ...state,
      manageHeaderActionsCallout: {
        isOpen: false,
        element: undefined,
        index: undefined,
        data: undefined,
      },
    });
    let xlsxRaw = await await fetch(
      `${API_URL}temp-rh/report/excel?startDate=${moment(
        state.searchObj.startDate
      )
        .startOf("month")
        .format("YYYY-MM-DD")}&endDate=${moment(state.searchObj.endDate)
        .endOf("month")
        .format("YYYY-MM-DD")}&tempRhPageId=${tempRhPageId}&datacenterId=${
        state.searchObj.datacenterId
      }&isAmbient=${false}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: { at: getToken() },
      }
    );

    let xlsx = await xlsxRaw.blob();
    const xlsxFile = await new Blob([xlsx], {
      type: "application/vnd.openxmlformats",
    });
    const xlsxFileURL = await URL.createObjectURL(xlsxFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = xlsxFileURL;

    a.download = `${pageName} page data.xlsx`;
    a.click();
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let tempHumidity = undefined;
    if (index !== undefined) {
      tempHumidity = { ...state.tempHumidity[index] };
    }
    setState({
      ...state,
      manageTempRhDialog: {
        isOpen,
        index,
        data: tempHumidity,
      },
    });
  };

  const handleDialogClose = () => {
    let obj = {
      ...state,
      manageTempRhDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
    };
    setState(obj);
    // getTempHumidity(obj);
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap} className="pt-16">
        {/* <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: state.customer.name,
                key: 'name',
                onClick: () => {
                  history.push(`/customers/${state.customer._id}`);
                },
              },
              {
                text: 'Temperature & Humidity',
                key: 'temperature-humidity',
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item> */}
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
          >
            <Stack.Item>
              <Stack tokens={childrenGap} horizontal horizontalAlign="start">
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a datacenter"
                    selectedKey={state.searchObj.datacenterId}
                    // defaultSelectedKey={state.searchObj.datacenterId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.datacenterDropdown}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            datacenterId: v.key as string,
                          },
                        });
                        // console.log("v", v.key);
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  {/* <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    value={state.date}
                    showGoToToday={false}
                    showMonthPickerAsOverlay={true}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        date: date as any,
                        searchObj: {
                          ...state.searchObj,
                          startDate: moment(date).startOf("month").toDate(),
                          endDate: moment(date).endOf("month").toDate(),
                        },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                  /> */}
                  <div
                    ref={(calendarBtn) =>
                      (calendarButtonElement = calendarBtn!)
                    }
                  >
                    <DefaultButton
                      text={
                        !state.date
                          ? "Select a month"
                          : moment(state.date).format("MMM-YYYY")
                      }
                      onClick={() =>
                        setState({ ...state, showCallender: true })
                      }
                      className="month-picker-btn"
                    />
                  </div>
                  {state.showCallender && (
                    <Callout
                      isBeakVisible={false}
                      // className="ms-DatePicker-callout"
                      gapSpace={0}
                      doNotLayer={false}
                      target={calendarButtonElement}
                      directionalHint={DirectionalHint.bottomLeftEdge}
                      onDismiss={() => closeCallender()}
                      setInitialFocus
                    >
                      <FocusTrapZone
                        firstFocusableSelector="ms-DatePicker-day--today"
                        isClickableOutsideFocusTrap
                      >
                        <Calendar
                          // eslint-disable-next-line react/jsx-no-bind
                          onSelectDate={(date: Date | null | undefined) =>
                            setState({
                              ...state,
                              date: date as any,
                              searchObj: {
                                ...state.searchObj,
                                startDate: moment(date)
                                  .startOf("month")
                                  .toDate(),
                                endDate: moment(date).endOf("month").toDate(),
                              },
                              showCallender: false,
                            })
                          }
                          onDismiss={() => closeCallender()}
                          isMonthPickerVisible={true}
                          value={state.date}
                          firstDayOfWeek={DayOfWeek.Sunday}
                          strings={DayPickerStrings}
                          isDayPickerVisible={false}
                          highlightCurrentMonth={false}
                          highlightSelectedMonth={true}
                          showMonthPickerAsOverlay={false}
                          showGoToToday={false}
                        />
                      </FocusTrapZone>
                    </Callout>
                  )}
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack tokens={childrenGap} wrap horizontal horizontalAlign="end">
            {/* <Stack.Item>
              <PrimaryButton
                text="Download Report"
                disabled={
                  state.isLoading === true || state.tempHumidity.length === 0
                }
                onClick={() => downloadTempRhReportPdf()}
                // className="custom-secondary-btn"
              />
            </Stack.Item> */}
            <Stack.Item>
              <PrimaryButton
                text="Add Page"
                onClick={() => handlePageDialogOpenClose(true)}
              />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Fabric>
            <ShimmeredDetailsList
              items={state.tempHumidity}
              groups={state.group}
              columns={[
                {
                  key: "date",
                  name: "Date",
                  fieldName: "date",
                  minWidth: 200,
                  maxWidth: 250,
                  isResizable: true,
                },
                {
                  key: "temp",
                  name: "Temperature",
                  fieldName: "temp",
                  minWidth: 200,
                  maxWidth: 250,
                  isResizable: true,
                },
                {
                  key: "rh",
                  name: "Humidity",
                  fieldName: "rh",
                  minWidth: 200,
                  maxWidth: 250,
                  isResizable: true,
                },
                {
                  key: "actions",
                  name: "Actions",
                  fieldName: "actions",
                  minWidth: 200,
                  maxWidth: 250,
                  isResizable: true,
                },
              ]}
              groupProps={{
                onRenderHeader: _onRenderGroupHeader,
              }}
              onRenderItemColumn={_renderItemColumn as any}
              onRenderDetailsHeader={_onRenderDetailsHeader as any}
              // onShouldVirtualize={() => false}
              // enableShimmer={state.isLoading}
              compact={true}
              setKey="tempHumidity"
              layoutMode={DetailsListLayoutMode.justified}
              selectionMode={SelectionMode.none}
              // listProps={shimmeredDetailsListProps}
            />
          </Fabric>
        </Stack.Item>
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout &&
            state.manageActionsCallout.data?.quadrantId
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
          // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                View
              </span>
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    setState({
                      ...state,
                      tempRhObj: {
                        date: state.manageActionsCallout.data.actualDate,
                        temp:
                          state.manageActionsCallout.data?.temp !== "NA"
                            ? (state.manageActionsCallout.data.temp as number)
                            : 0,
                        rh:
                          state.manageActionsCallout.data?.rh !== "NA"
                            ? (state.manageActionsCallout.data.rh as number)
                            : 0,
                        // quadrantId: state.manageActionsCallout.data?.quadrantId,
                        // floorId: state.manageActionsCallout.data?.floorId,
                        // datacenterId:
                        //   state.manageActionsCallout.data?.datacenterId,
                        // customerId: params.customerId,
                        tempRhPageId:
                          state.manageActionsCallout.data.tempRhPageId,
                      },
                      manageActionsCallout: {
                        ...state.manageActionsCallout,
                        isOpen: false,
                      },
                      isOnEdit: true,
                    });
                  }}
                  className="callout-options"
                >
                  Edit
                </span>
              </Stack.Item>
            )}
          </Stack>
        </Callout>
      )}
      {state.manageHeaderActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 210, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageHeaderActionsCallout &&
            state.manageHeaderActionsCallout.data?.group?.key
          }
          gapSpace={0}
          target={state.manageHeaderActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleHeaderCallOutOpenClose(false)}
          // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    handlePageDialogOpenClose(
                      true,
                      state.manageHeaderActionsCallout.index
                    );
                  }}
                  className="callout-options"
                >
                  Edit Page
                </span>
              </Stack.Item>
            )}
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    deletePage(
                      state.manageHeaderActionsCallout.data?.group
                        ?.key as string,
                      state.manageHeaderActionsCallout.index as number
                    );
                  }}
                  className="callout-options"
                >
                  Delete Page
                </span>
              </Stack.Item>
            )}
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleRemarksDialogOpenClose(
                    true,
                    state.manageHeaderActionsCallout.index
                  );
                }}
                className="callout-options"
              >
                View Remarks
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  downloadTempRhReportPdf(
                    state.manageHeaderActionsCallout.data?.group?.key as string,
                    state.manageHeaderActionsCallout.data?.group?.name as string
                  );
                }}
                className="callout-options"
              >
                Download PDF Report
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  downloadTempRhReportExcel(
                    state.manageHeaderActionsCallout.data?.group?.key as string,
                    state.manageHeaderActionsCallout.data?.group?.name as string
                  );
                }}
                className="callout-options"
              >
                Download Excel Report
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageTempRhDialog.isOpen && (
        <ManageTemperatureHumidityDetails
          handleDialogClose={() => handleDialogClose()}
          data={state.manageTempRhDialog.data}
          slaMatrix={state.slaMatrix}
          customerId={params.customerId}
        />
      )}
      {state.managePageDialog.isOpen && (
        <ManageTempRhPageDialog
          handleDialogClose={(data?: any) =>
            handlePageDialogOpenClose(false, undefined, data ? true : false)
          }
          tempRhPageId={state.managePageDialog.tempRhPageId}
          customerId={params.customerId}
          datacenterId={state.searchObj.datacenterId as string}
          sequence={state.group.length + 1}
          datacenter={
            state.datacenters.find(
              (d) => d._id === state.searchObj.datacenterId
            ) as IDataCenter
          }
          reportConfig={
            state.powerReportConfig.find(
              (d) => d.datacenterId === state.searchObj.datacenterId
            ) as IPowerReportConfigurations
          }
        />
      )}
      {state.manageRemarksDialog.isOpen && (
        <React.Fragment>
          <CustomDrawer
            title={`View Temp/RH Remarks for ${state.manageRemarksDialog.pageName}`}
            handelOpen={true}
            onClose={() => handleRemarksDialogOpenClose(false)}
          >
            <TempRhRemarks
              tempRhPageId={state.manageRemarksDialog.tempRhPageId}
              customerId={params.customerId}
              datacenterId={state.searchObj.datacenterId as string}
              date={state.searchObj.startDate}
            />
          </CustomDrawer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default TemperatureHumidityMain;
